export enum TipoOrdemServicoEnum {

  ERRO = "Erro de sistema",
  MELHORIA = "Melhoria",
  MELHORIA_FUTURA = "Melhoria para o futura",
  NOVA_FUNCIONALIDADE = "Nova funcionalidade",
  OPERACIONAL = "Procedimento operacional"
}
